import Header from "../../componants/header";
import Footer from "../../componants/footer";
import BannerForAll from "../../componants/bannerForAll";
import mongodbImage from '../../images/cardpageimages/technicalcourse/databaseMangaementImage.jpg';
import IntroVideos from "../../componants/introvideos";
import DatabaseManagementModule from "../../componants/allCourseModule/TechnicalCourseModule/DatabaseManagementModule";

function DatabaseManagementMongoDB() {
  return (
    <>
      <Header />
      <BannerForAll
        title="DATABASE MANAGEMENT WITH MONGODB FULL COURSE"
        text="Our Database Management with MongoDB Full Course provides an in-depth understanding of NoSQL databases and MongoDB. You’ll learn how to manage, design, and query databases with MongoDB, one of the most popular document-based databases. This course covers data modeling, indexing, CRUD operations, aggregation pipelines, and database management best practices, equipping you to work with large-scale data-driven applications."
        imageone={mongodbImage}
        imagetwo={mongodbImage}
      />
      <IntroVideos
        vone="https://www.youtube.com/embed/dQw4w9WgXcQ"
        vtwo="https://www.youtube.com/embed/3JZ_D3ELwOQ"
        topic="DATABASE MANAGEMENT WITH MONGODB"
      />
      <DatabaseManagementModule />
      <Footer />
    </>
  );
}

export default DatabaseManagementMongoDB;
